import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";
import { createAction } from "@reduxjs/toolkit";
import download from "downloadjs";

const slice = createSlice({
  name: "certificate",
  initialState: {
    transactionInformation: [],
    certificateHolderDetail: [],
    allCertiifcateList: [],
    allCertificateStart: false,
    pdfCertificate: false,
    addCertificateResp: "",
    updateErrors: [],
    singleCertificateObj: {},
    certificateFlag: {},
    locationObject: {},

  },
  reducers: {
    
    informationRetrieving: (certificate, action) => {
      certificate.transactionInformation = [];
    },
    informationRetrieved: (certificate, action) => {
      certificate.transactionInformation = action.payload ? action.payload : [];
    },
    informationRetrievalFailed: (certificate, action) => {
      certificate.transactionInformation = action.payload;
    },
    detailsUpdating: (certificate, action) => {
      certificate.certificateHolderDetail = true;
    },
    certificateHolderDetails: (certificate, action) => {
      certificate.certificateHolderDetail = action.payload?.data
        ? action.payload
        : [];
    },
    allCertificateList: (certificate, action) => {
      certificate.allCertiifcateList = action.payload ? action.payload : [];
    },
    allCertificateListStart: (certificate, action) => {
      certificate.allCertificateStart = true;
    },
    // pdfCertificate: (certificate, action) => {
    //   certificate.pdfCertificate = true;
    // },
    allCertificateListFailed: (certificate, action) => {
      certificate.allCertiifcateList = false;
    },

    addCertificateHolderSuccess: (certificate, action) => {
      certificate.addCertificateResp = action.payload ? action.payload : "";
    },
    detailsUpdateFailed: (certificate, action) => {
      certificate.certificateHolderDetail = false;
      certificate.updateErrors = action.payload ? action.payload : "Error";
    },
    pdfCertificate: (certificate, action) => {
      let downloadingEml = action?.payload?.extras?.downloadingEml;
      console.log('spot price downloadingEml',downloadingEml)
      certificate.pdfCertificate = true;
      
      if (downloadingEml) {
        console.log('--- EML Generation ---');
console.log('Action Payload:', action.payload);
console.log('Response for EML:', action.payload.response);
console.log('Type of response:', typeof action.payload.response);
console.log('Is it a Blob?', action.payload.response instanceof Blob);
if (action.payload.response instanceof Blob) {
    console.log('Blob size:', action.payload.response.size);
    console.log('Blob type:', action.payload.response.type);
}
console.log('Extras:', action.payload.extras);
        certificate.gettingPdfv2 = true;
        let bcc = action.payload.extras.bcc;
        let body = action.payload.extras.body;
        let subject = action.payload.extras.subject;
        let mailto = action.payload.extras.mailto;
        let holderName = action.payload.extras.holderName;
        let reader = new FileReader();
        reader.readAsDataURL(action.payload.response);
        reader.onloadend = function () {
          var base64data = reader.result.split(",")[1];

          /////////////////// EML FILE LOGIC///////////

          // let emlContent = "data:message/rfc822 eml;charset=utf-8,";
          let emlContent = "To: " + mailto + "\n";
          emlContent += "bcc: " + bcc + "\n";
          emlContent += `Subject: ${subject}\n`;
          emlContent += "X-Unsent: 1\n";
          emlContent +=
            "Content-Type: multipart/mixed; boundary=0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent += "Mime-Version: 1.0\n";

          emlContent +=
            "\n--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";
          emlContent += `Content-Type: application/pdf; name=Certificate for ${holderName}${
            new Date().toISOString().split(`T`)[0]
          }.pdf\n`;
          emlContent += "Content-Transfer-Encoding: base64\n";
          emlContent += "Content-Disposition: attachment\n\n";

          emlContent += base64data + "\n\n";
          emlContent +=
            "--0e70ee49840ae443b30627e98069efba0b0b9e909d0e5f68aa1d3176c2d4\n";

          emlContent += body;

          const emlBlob = new Blob([emlContent], { type: "message/rfc822;charset=utf-8" });
          download(emlBlob, "OpenWithOutlook.eml", "message/rfc822");
        };
      } else {
        certificate.pdfCertificate = pdfCertificate.success;
        // certificate.currentblobcontent =
        //   action.payload.fullresponse.headers["content-type"];
        console.log('emails check',action?.payload)
        if(action?.payload!=undefined&&action?.payload?.extras.holderName!=undefined&&action?.payload?.extras?.date!=undefined){
        download(
          action?.payload?.response,
          `Certificate for ${action?.payload?.extras.holderName} ${action?.payload?.extras?.date}`,
          action?.payload?.fullresponses?.headers["content-type"]
        );
      }
      }
    },
    singleCertificateDataList: (certificate, action) => {
      console.log(certificate);
      certificate.singleCertificateObj = action.payload;
    },
    certificateDataClear: (certificate, action) => {
      console.log(certificate);
      console.log(action);
      certificate.singleCertificateObj = {};
    },
    certificateFalg: (certificate, action) => {
      certificate.certificateFlag = action.payload ? action.payload : {};
    },
    locationObjForEditCopy: (certificate, action) => {
      certificate.locationObject = action.payload;
    },
  },
});

export const {
  singleCertificateDataList,
  certificateDataClear,
  certificateFalg,
  informationRetrieving,
  informationRetrieved,
  informationRetrievalFailed,
  detailsUpdating,
  certificateHolderDetails,
  allCertificateList,
  allCertificateListStart,
  pdfCertificate,
  allCertificateListFailed,
  addCertificateHolderSuccess,
  detailsUpdateFailed,
  locationObjForEditCopy,
} = slice.actions;

export default slice.reducer;
export const addCertificateHolder = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/certificate/add-certificate-holder",
    method: "post",
    data: data,
    // onStart: gettingBindersInitialized.type,
    onSuccess: addCertificateHolderSuccess.type,
    // onError: gettingBindersFailed.type,
  });

export const allCertificateHolderList = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/certificate/get-all-additional-insurer-and-loss-payee/" + data,
    method: "get",
    // onStart: detailsUpdating.type,
    onSuccess: certificateHolderDetails.type,
    // onError: detailsUpdateFailed.type,
  });
export const allCertificateDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/certificate/get-all-certificate-by-policy/" + data,
    method: "get",
    onStart: allCertificateListStart.type,
    onSuccess: allCertificateList.type,
    // onError: allCertificateListFailed.type,
  });
export const downloadCertificate = (
  certfId,
  data,
  holderName,
  languagePreference = "en"
) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: `/api/certificate/get-certificate-pdf/${certfId}`,
    method: "get",
    onStart: pdfCertificate.type,
    onSuccess: pdfCertificate.type,
    considerPayloads: true,
    responseType: "blob",
    params: {
      pdf_language_selected: languagePreference.toLowerCase(),
    },
    onSuccessPayload: {
      downloadingEml: data?.downloadingEml,
      mailto: data?.mailto,
      bcc: data?.bcc,
      body: data?.body,
      subject: data?.subject,
      holderName: holderName,
      date: new Date().toISOString().split(`T`)[0],
      languagePreference: languagePreference,
    },
    // onError: allCertificateListFailed.type,
  });

export const getCertificateHolderListDetails = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.certificateHolderDetail.data
);
export const getAddCertificateHolderResponse = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.addCertificateResp
);
export const getAllCertificateList = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.allCertiifcateList
);
export const getSingleCertificateList = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.singleCertificateObj
);
export const getCertificateFlag = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.certificateFlag
);
export const getDownloadedCertificate = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.pdfCertificate
);
export const getLocationObjectValue = createSelector(
  (state) => state.entities.certificate,
  (certificate) => certificate.locationObject
);
